<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form data-vv-scope="add-new-report">
        <vx-card :title="$t('AddReport') | ToUppercase">
        <!-- <div class="vx-row">
            <div class="vx-col mb-2">
        <vs-select v-validate="'required'" name="shift" :label="$t('Shift') |ToUppercase" class="w-full ml-base" v-model="shift">
          <vs-select-item
            v-for="shift in shifts"
            :text='shift.name + ", " + $moment(shift.datetime).format("d. M. YYYY, H:mm")'
            :value="shift.id"
            :key="shift.id"
          />
        </vs-select>
        <span
          class="text-danger mb-2"
          v-show="errors.has(`add-new-report.shift`)"
        >{{ errors.first(`add-new-report.shift`) }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col ml-2">
              <vs-upload
                id="report"
                name="report"
                @change="onReportChange"
                @on-delete="onReportDelete"
                :multiple="false"
                :show-upload-button="false"
                :limit="1"
                accept=".pdf, .docx, .doc, .xlsx, .xls"
                :text="$t('AddReport') | ToUppercase"
              />
                      <span
          class="text-danger mb-2"
          v-show="report == null && upload"
        >The report field is required.</span>
            </div>
          </div> -->
          <vs-tabs>
            <vs-tab label="Poročilo avtomatske blagajne">
              <div class="con-tab-ejemplo">
                <ReportTemplate :report="report1" vvFormScope="add-new-report"></ReportTemplate>
              </div>
            </vs-tab>
            <vs-tab label="Dnevno poročilo blagajne">
              <div class="con-tab-ejemplo">
                <ReportTemplate2 :report="report2" vvFormScope="report2"></ReportTemplate2>
              </div>
            </vs-tab>
            <vs-tab label="Dnevnik delovnih ur">
              <div class="con-tab-ejemplo">
                <!-- <ReportTemplate :report="report1" vvFormScope="report"></ReportTemplate> -->
              </div>
            </vs-tab>
            <vs-tab label="Evidenca prisotnosti na delu">
              <div class="con-tab-ejemplo">
                <ReportTemplate3 :report="report3" vvFormScope="report3"></ReportTemplate3>
              </div>
            </vs-tab>
          </vs-tabs>
          <div class="vx-row">
            <div class="vx-col w-full ml-6">
              <vs-button @click="submitForm" class="mr-3 m-2">{{$t('Add') | ToUppercase}}</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ReportTemplate from '../components/ReportTemplate1'
import ReportTemplate2 from '../components/ReportTemplate2'
import ReportTemplate3 from '../components/ReportTemplate3'

import { quillEditor } from 'vue-quill-editor'
export default {
  components: {
    quillEditor,
    ReportTemplate,
    ReportTemplate2,
    ReportTemplate3
  },
  $_veeValidate: {
    validator: "new",
  },
  created() {
    this.$store.dispatch("shift/fetchShifts");
  },
  computed: {
    shifts(){
      return this.$store.state.shift.shifts.slice();
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  data: function () {
    return {
      report: null,
      shift: "",
      docID: 0,
      filename: "",
      upload: false,
      content: "",
      report1: {
        date: new Date(),
        report010: {value: 0.10, amount: 0},
        report020: {value:0.20, amount: 0},
        report050: {value: 0.50, amount: 0},
        report1: {value: 1, amount: 0},
        report2: {value: 2, amount: 0},
        report5: {value: 5, amount: 0},
        report10: {value: 10, amount: 0},
        report20: {value: 20, amount: 0},
        report50: {value: 50, amount: 0},
        reportp010: {value: 0.10, amount: 0},
        reportp020: {value: 0.20, amount: 0},
        reportp050: {value: 0.50, amount: 0},
        reportp1: {value: 1, amount: 0},
        reportp5: {value: 5, amount: 0},
        reportp10: {value: 10, amount: 0},
        note: ""
      },
      report2: {
        date: new Date(),
        person1: {},
        person2: {},
        person3: {},
        person4: {},
        person5: {},
        person6: {},
      },
      report3: {
        personID: 0,
        date1: {date: "1. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date2: {date: "2. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date3: {date: "3. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date4: {date: "4. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date5: {date: "5. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date6: {date: "6. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date7: {date: "7. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date8: {date: "8. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date9: {date: "9. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date10: {date: "10. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date11: {date: "11. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date12: {date: "12. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date13: {date: "13. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date14: {date: "14. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date15: {date: "15. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date16: {date: "16. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date17: {date: "17. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date18: {date: "18. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date19: {date: "19. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date20: {date: "20. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date21: {date: "21. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date22: {date: "22. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date23: {date: "23. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date24: {date: "24. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date25: {date: "25. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date26: {date: "26. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date27: {date: "27. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date28: {date: "28. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date29: {date: "29. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date30: {date: "30. 10. 2020", morning: 0, afternoon: 0, night: 0},
        date31: {date: "31. 10. 2020", morning: 0, afternoon: 0, night: 0},
      },
    };
  },
  methods: {
    onReportDelete() {
      this.report = null;
    },
    onReportChange() {
      var input = document.getElementById("report");
      this.report = input.files[0];
    },
    createJsonObject() {
      let payload = {
        shiftID: this.shift,
        document: {
          file: this.report,
        },
        userID: this.$store.state.AppActiveUser.id,
        docID: this.docID,
        filename: this.fileName
      };
      return payload;
    },
    async submitForm() {
      this.upload = true;
      let isFormValid = await this.$validator.validateAll("add-new-report");
      if (!isFormValid) return;
      if(this.report == null) return;

      this.$vs.loading();

      try {
         let res = await this.uploadFile();

         if (res.status == 200) {
           this.docID = res.data.docID;
           this.fileName = res.data.fileName;
           let payload = this.createJsonObject();
           console.log(payload);
            let response = await this.$store.dispatch(
              "report/addReport",
              payload
            );

            if (response.status == 200) {
              this.$vs.notify({
                text: this.$t("SuccessfullyAdded"),
                color: "success",
                iconPack: "feather",
                icon: "icon-check-circle",
              });
              this.$router.push(`/report/${response.data}`);
            }
         }
       } catch (error) {
         this.$vs.notify({
           title: this.$t("Error"),
           text: error,
           iconPack: "feather",
           icon: "icon-alert-circle",
           color: "danger",
         });
      } finally {
        this.$vs.loading.close();
      }
    },
    async uploadFile() {
      try {
        let res = await this.$store.dispatch("report/addFileToReport", {
          report: this.report,
        });
        return Promise.resolve(res);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }
};
</script>
